import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useFormAction, useNavigate } from 'react-router-dom';
import Button from '../../Component/Button/index';
import CheckoutStep from '../../Component/CheckOutStep';
import { saveShippingAddress } from '../../redux/actions/cartAction';

import './shippingAddressScreen.less';

export default function ShippingAddressScreen() {
  const userSignin = useSelector(state => state.userSignin);
  const cart = useSelector(state => state.cart);
  const { userInfo } = userSignin;

  const { shippingAddress } = cart;

  //console.log('cart: ', cart);
  //console.log('shippingAddress: ', shippingAddress);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Inicialización segura de estados usando el encadenamiento opcional (?) y valores por defecto
  const [fullName, setFullName] = useState(shippingAddress?.fullName || ' ');
  const [address, setAddress] = useState(shippingAddress?.address || ' ');
  const [city, setCity] = useState(shippingAddress?.city || ' ');
  const [postalCode, setPostalCode] = useState(
    shippingAddress?.postalCode || ' '
  );
  const [country, setCountry] = useState(shippingAddress?.country || ' ');

  // Redireccionar si el usuario no está autenticado
  useEffect(() => {
    if (!userInfo) {
      navigate('/signin');
    }
  }, []);

  const submitHandler = e => {
    e.preventDefault();
    // Despachar la acción de guardar dirección de envío
    // Nota: En un proyecto real, se usaría una acción definida (p. ej., saveShippingAddress)
    // TODO: dispatch save shipping address action

    dispatch(
      saveShippingAddress({
        fullName,
        address,
        city,
        postalCode,
        country,
      })
    );
    //console.log('Shipping Address saved:');
    navigate('/payment');
  };

  return (
    <div>
      <CheckoutStep step1 step2></CheckoutStep>

      <form className="shipping-address-form" onSubmit={submitHandler}>
        <div>
          <h1>Shipping Address</h1>
          <div>
            {/* Full Name Input */}
            <div>
              {' '}
              <label htmlFor="fullName">Full Name</label>
              <input
                type="text"
                id="fullName"
                placeholder="Enter full name"
                value={fullName}
                onChange={e => setFullName(e.target.value)}
                required
              />
            </div>
            {/* Address Input */}
            <div>
              <label htmlFor="address">Address</label>
              <input
                type="text"
                id="address"
                placeholder="Enter Address"
                value={address}
                onChange={e => setAddress(e.target.value)}
                required
              />
            </div>
            {/* City Input */}
            <div>
              <label htmlFor="city">City</label>
              <input
                type="text"
                id="city"
                placeholder="Enter city"
                value={city}
                onChange={e => setCity(e.target.value)}
                required
              />
            </div>
            {/* Postal Code Input */}
            <div>
              <label htmlFor="postalCode">Postal Code</label>
              <input
                type="text"
                id="postalCode"
                placeholder="Enter Postal Code"
                value={postalCode}
                onChange={e => setPostalCode(e.target.value)}
                required
              />
            </div>
            {/* Country Input */}
            <div>
              <label htmlFor="country">Country</label>
              <input
                type="text"
                id="country"
                placeholder="Enter country"
                value={country}
                onChange={e => setCountry(e.target.value)}
                required
              />
            </div>
            {/* Submit Button */}
            <div>
              <label />
              <Button type="submit"> Continue</Button>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}
